/**
 * Find the organization that matches the given appName, returns the management
 * object which includes users and roles.
 * @param {Object} sinatra - The sinatra state
 * @param {string} orgId - The organization ID
 * @param {string} appName - The name of the application to match
 */
export const selectManagementByApp = (sinatra, orgId, appName) => {
  const org = sinatra.management.organizations[orgId];
  if (!org) {
    return undefined;
  }
  const found = org.apps[appName];
  if (!found) {
    return undefined;
  }
  return found;
};

export default selectManagementByApp;
